<template>
  <div class="flex justify-between">
    <div class="font-bold">
      Vat Prod:
    </div>
    <div>
      {{ bcVatProd ? `${getVatProd(bcVatProd)}` : 'ไม่ระบุ' }}
    </div>
  </div>
  <div class="flex justify-between">
    <div class="font-bold">
      WHT BUS:
    </div>
    <div>
      {{ bcWhtBus ? `${getWhtBus(bcWhtBus)}` : 'ไม่ระบุ' }}
    </div>
  </div>
  <div class="flex justify-between">
    <div class="font-bold">
      WHT Prod:
    </div>
    <div>
      {{ bcWhtProd ? `${getWhtProd(bcWhtProd)}` : 'ไม่ระบุ' }}
    </div>
  </div>
  <div class="flex justify-between">
    <div class="font-bold">
      Branch:
    </div>
    <div>
      {{ bcElim ? `${getElim(bcElim)}` : 'ไม่ระบุ' }}
    </div>
  </div>
</template>

<script>
import { defineComponent, toRefs } from 'vue'
import { useStore } from '../store'

export default defineComponent({
  name: 'bcVatLabel',
  props: {
    bcVatProd: String,
    bcWhtBus: String,
    bcWhtProd: String,
    bcElim: String
  },
  // emits: ['update:vatProd', 'update:whtBus', 'update:whtProd', 'update:elim'],
  setup(props) {
    const store = useStore()
    // const bcVatProdOptions = computed(() => store.state.global.bcVatProd)
    // const bcWhtBusOptions = computed(() => store.state.global.bcWhtBus)
    // const bcWhtProdOptions = computed(() => store.state.global.bcWhtProd)
    // const bcElimOptions = computed(() => store.state.global.bcElim)

    // const vatProd = ref(props.bcVatProd)
    // const whtBus = ref(props.bcWhtBus)
    // const whtProd = ref(props.bcWhtProd)
    // const elim = ref(props.bcElim)

    const getVatProd = val => {
      return store.getters['global/getBcVatProd'](val)
    }
    const getWhtBus = val => {
      return store.getters['global/getBcWhtBus'](val)
    }
    const getWhtProd = val => {
      return store.getters['global/getBcWhtProd'](val)
    }
    const getElim = val => {
      return store.getters['global/getBcElim'](val)
    }

    return {
      ...toRefs(props),
      // bcVatProdOptions,
      // bcWhtBusOptions,
      // bcWhtProdOptions,
      // bcElimOptions,
      // vatProd,
      // whtBus,
      // whtProd,
      // elim
      getVatProd,
      getWhtBus,
      getWhtProd,
      getElim
    }
  }
})
</script>

<style scoped></style>
